export interface DiscountI {
  id: string;
  discountCode: string;
  discountType?: string;
  discountAmount?: number;
  // Aligned with the Prisma `Discount.expiresAt` column (#712). ISO date string
  // (e.g. `2025-12-31`) as emitted by an `<input type="date">`.
  expiresAt?: string;
  discountContactId?: string | null;
  discountContactName?: string | null;
  discountContactEmail?: string | null;
  discountForEventId?: string | null;
  isCustomerDiscount?: boolean;
  discountDescription?: string | null;
  discountForTrainerId?: string | null;
  // #1522: required by the create DTO (CreateDiscountDto) — max number of
  // redemptions and the discount duration descriptor.
  maxRedeemption?: number;
  duration?: string;
  // #712: also exposed on CreateDiscountDto — the Stripe coupon `duration_in_months`
  // (only meaningful when `duration` is `repeating`) and the active/paused flag.
  duration_in_months?: number;
  isActive?: boolean;
  createdAt?: Date | null;
  updatedAt?: Date | null;
}

export enum DiscountTypesEnum {
  ONE_TIME = 'One Time',
  TEST = 'Test',
  MEAL_PLAN = 'Meal Plan',
}
